function formatQuery(query) {
  // If the query is an array, process each element.
  if (Array.isArray(query)) {
    return query.map(item => formatQuery(item));
  }
  // If the query is a non-null object, process each key-value pair.
  else if (query !== null && typeof query === 'object') {
    const newQuery = {};
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        let newKey = key;
        // Skip transformation for operator keys.
        if (!key.startsWith('$')) {
          if (key === 'email') {
            newKey = 'email.address';
          } else {
            newKey = 'properties.' + key;
          }
        }
        newQuery[newKey] = formatQuery(query[key]);
      }
    }
    return newQuery;
  }
  // For non-object and non-array values, return them as is.
  else {
    return query;
  }
}

export default formatQuery;

